module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (153).ad7ae4c5.jpg";